export default "__VITE_ASSET__BKZmwJZO__"